const pages = ['settings', 'Game Rules', 'Provably Fair', 'History']

export const usePages = (enableLoading: boolean) => {
  return enableLoading ? pages : []
}
